<template>
  <div>
    <vs-popup
      :title="titleSideBar"
      :active.sync="modalForm"
      @close="closeModais"
    >
      <formAddRegional :dados="dados" @close="closeModais" :modal="modalForm">
      </formAddRegional>
    </vs-popup>
    <form role="form" @submit.stop.prevent="onSubmit">
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6 flex flex-col gap-3">
          <span>Foto de Perfil do Usuário</span>
          <img
            v-if="urlFoto"
            :src="urlFoto"
            alt="Foto de perfil"
            class="w-40 h-40 object-cover rounded-full border border-solid border-black"
          />
          <input
            accept=".jpg,.jpeg,.png"
            @change="selecionaArquivoUpload"
            type="file"
            id="uploadFoto"
          />
          <small>Formatos permitidos: .jpg, .jpeg, .png</small>
          <p v-if="erroImagem" class="warning">{{ erroImagem }}</p>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-1/2 mb-6">
          <span>Consultor</span>
          <vs-switch
            color="success"
            v-model="formCadastro.consultor"
            style="width: 60px"
            @change="handleSwitchChange"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
        <div class="vx-col w-1/2 mb-6">
          <span>Pode Fazer Vistoria</span>
          <vs-switch
            color="success"
            v-model="formCadastro.podeFazerVistoria"
            style="width: 60px"
          >
            <span slot="on">sim</span>
            <span slot="off">não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nome"
            v-validate="{ required: true, min: 6 }"
            :state="validateState('Nome')"
            :danger="validateClass('Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>UserName (sem acentos e sem espaço)</span>
          <vs-input
            size="large"
            class="w-full"
            name="UserName"
            id="UserName"
            v-model="formCadastro.userName"
            v-validate="{ required: true, min: 6 }"
            :state="validateState('UserName')"
            :danger="validateClass('UserName')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Email</span>
          <vs-input
            type="email"
            size="large"
            class="w-full"
            name="Email"
            id="Email"
            v-model="formCadastro.email"
            v-validate="{ required: true, email: true }"
            :state="validateState('Email')"
            :danger="validateClass('Email')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-mail"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CPF/CNPJ</span>
          <vs-input
            size="large"
            class="w-full"
            name="CPF"
            id="CPF"
            v-model="formCadastro.cpf"
            v-validate="{ required: true, min: 14 }"
            :state="validateState('CPF')"
            :danger="validateClass('CPF')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="cpfCnpjMask"
            @input="updateMask"
            icon-pack="feather"
            icon="icon-user-check"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Celular</span>
          <vs-input
            size="large"
            class="w-full"
            name="Celular"
            id="Celular"
            v-model="formCadastro.celular"
            v-validate="{ required: true }"
            :state="validateState('Celular')"
            :danger="validateClass('Celular')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'(##) #####-####'"
            icon-pack="feather"
            icon="icon-smartphone"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Telefone</span>
          <vs-input
            size="large"
            class="w-full"
            name="Telefone"
            id="Telefone"
            v-model="formCadastro.telefone"
            :state="validateState('Telefone')"
            :danger="validateClass('Telefone')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'(##) ####-####'"
            icon-pack="feather"
            icon="icon-phone"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Data de Nascimento</span>
          <vs-input
            size="large"
            class="w-full"
            name="Data de Nascimento"
            id="Data de Nascimento"
            v-model="formCadastro.dataNascimento"
            v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
            :state="validateState('Data de Nascimento')"
            :danger="validateClass('Data de Nascimento')"
            val-icon-danger="clear"
            v-mask="'##/##/####'"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-calendar"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CEP</span>
          <vs-input
            size="large"
            class="w-full"
            name="Cep"
            id="Cep"
            @keyup.native="keymonitor"
            v-model="formCadastro.cep"
            v-validate="{ required: true, min: 10 }"
            :state="validateState('Cep')"
            :danger="validateClass('Cep')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'##.###-###'"
            icon-pack="feather"
            icon="icon-home"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Endereço</span>
          <vs-input
            size="large"
            class="w-full"
            name="Endereço"
            id="Endereço"
            v-model="formCadastro.endereco"
            v-validate="{ required: true, min: 6 }"
            :state="validateState('Endereço')"
            :danger="validateClass('Endereço')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-map-pin"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Número</span>
          <vs-input
            size="large"
            class="w-full"
            name="Numero"
            id="Numero"
            v-model="formCadastro.numero"
            v-validate="{ required: true }"
            :state="validateState('Numero')"
            :danger="validateClass('Numero')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-check-circle"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Complemento</span>
          <vs-input
            size="large"
            class="w-full"
            name="Complemento"
            id="Complemento"
            v-model="formCadastro.complemento"
            :state="validateState('Complemento')"
            :danger="validateClass('Complemento')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-check-circle"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Bairro</span>
          <vs-input
            size="large"
            class="w-full"
            name="Bairro"
            id="Bairro"
            v-model="formCadastro.bairro"
            v-validate="{ required: true }"
            :state="validateState('Bairro')"
            :danger="validateClass('Bairro')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-map-pin"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cidade</span>
          <vs-input
            size="large"
            class="w-full"
            name="Cidade"
            id="Cidade"
            v-model="formCadastro.cidade"
            v-validate="{ required: true }"
            :state="validateState('Cidade')"
            :danger="validateClass('Cidade')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-map"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Estado</span>
          <vs-input
            size="large"
            class="w-full"
            name="Estado"
            id="Estado"
            v-model="formCadastro.estado"
            v-validate="{ required: true, min: 2, max: 2 }"
            :state="validateState('Estado')"
            :danger="validateClass('Estado')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-navigation"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Setor</span>
          <v-select
            :options="setores"
            name="Setor"
            id="Setor"
            :create-option="criaSetor"
            v-model="formCadastro.idSetor"
            v-validate="{ required: true }"
            :state="validateState('Setor')"
            :danger="validateClass('Setor')"
          ></v-select>
        </div>
      </div>

      <div v-if="$can('Permite editar Perfil', 'Usuário')" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Perfil</span>
          <v-select
            :options="perfis"
            :create-option="criaPerfil"
            name="Perfil"
            id="Perfil"
            v-model="formCadastro.idPerfil"
            v-validate="{ required: true }"
            :state="validateState('Perfil')"
            :class="validateClass('Perfil')"
          ></v-select>
        </div>
      </div>

      <div v-if="!$can('Permite editar Perfil', 'Usuário')" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Perfil</span>
          <v-select
            :options="perfis"
            name="Perfil"
            id="Perfil"
            v-model="formCadastro.idPerfil"
            v-validate="{ required: true }"
            :state="validateState('Perfil')"
            :class="validateClass('Perfil')"
          ></v-select>
        </div>
      </div>

      <div
        class="vx-row mb-6"
        v-if="$can('Permitir alterar regional', 'Usuário')"
      >
        <div class="vx-col w-full">
          <span>{{ $t('Regional') }}</span>
          <div class="flex">
            <div class="vx-col mb-6 w-5/6">
              <v-select
                :options="regionais"
                name="Regional"
                id="Regional"
                class="w-full"
                :create-option="criaRegional"
                v-model="formCadastro.idRegional"
                @input="
                  buscaProgramaAfiliados(formCadastro.idRegional.id),
                    buscaDivisao(formCadastro.idRegional.id)
                "
                v-validate="{ required: true }"
                :state="validateState(translatedRegional)"
                :class="validateClass(translatedRegional)"
              >
              </v-select>
            </div>

            <div class="vx-col w-1/6 flex justify-end">
              <vs-button
                color="warning"
                type="filled"
                icon="add"
                @click.stop.prevent="openModalInsertEdit"
              ></vs-button>
            </div>
          </div>
        </div>

        <div class="vx-col w-full mb-6">
          <span>{{ $t('Divisão') }}</span>
          <v-select
            :options="divisoes"
            name="Divisão"
            label="label"
            id="idDivisao"
            v-model="formCadastro.idDivisao"
            class="select-large w-full"
            :reduce="(item) => item.id"
            v-validate="{ required: true }"
            :state="validateState(translatedDivision)"
            :danger="validateClass(translatedDivision)"
            multiple
            disabled
          ></v-select>
        </div>

        <div class="vx-col w-full mb-6" v-if="enabledGrandUnion">
          <span class="text-red font-normal text-sm mb-2" v-if="customClass"
            >*Campo Obrigatório</span
          >
          <GrandUnionFields
            :decoded="decoded"
            @onSelectedCustomPercentage="onSelectPercentagem"
            :isMobile="isMobile"
            class="border-blue border-2 border-solid p-6 rounded-lg"
            :class="[customClass]"
            :valorContribuicao="this.formCadastro.valorContribuicao"
          />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full mb-6">
          <span>Programa de Afiliados</span>
          <v-select
            :options="programasAfiliados"
            name="Programa de Afiliados"
            id="idProgramaAfiliado"
            v-model="programaEscolhido"
            class="select-large w-full"
            :reduce="(item) => item.id"
            :state="validateState('Programa de Afiliados')"
            :danger="validateClass('Programa de Afiliados')"
          ></v-select>
        </div>

        <div class="vx-col w-full mb-6">
          <span>Indicação</span>
          <v-select
            :options="usuariosUpline"
            name="Indicação"
            id="idUsuarioUpline"
            v-model="usuarioUplineEscolhido"
            class="select-large w-full"
            :reduce="(item) => item.id"
            :state="validateState('Indicação')"
            :danger="validateClass('Indicação')"
          ></v-select>
        </div>

        <div v-if="this.formCadastro.consultor" class="vx-col w-full mb-6">
          <label>Meta Padrão</label>
          <vs-input
            size="large"
            class="w-full"
            name="Meta"
            id="Meta"
            v-model="formCadastro.metaPadrao"
            v-validate="{ min: 1, max: 3 }"
            :state="validateState('Meta')"
            :danger="validateClass('Meta')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-crosshair"
            icon-no-border
          />
        </div>

        <div v-if="this.formCadastro.consultor" class="vx-col w-full mb-6">
          <label class="vs-select--label">Tipos Propostas Meta Padrão</label>
          <v-select
            :options="arrTtiposProposta"
            name="Tipos Proposta"
            label="label"
            id="TiposProposta"
            v-model="formCadastro.metaTipoPropostaPadrao"
            @input="emitChangedForm('idDivisao', form.metaTipoPropostaPadrao)"
            class="select-large w-full"
            :state="validateState('Divisão')"
            :danger="validateClass('Divisão')"
          ></v-select>
        </div>

        <div
          v-if="
            this.formCadastro.consultor &&
            this.$can('Permite alterar Status Pós Vistoria', 'Usuário')
          "
          class="vx-col w-full mb-6"
        >
          <label for="" class="vs-select--label"
            >Ao finalizar a Vistoria, a proposta vai para o status:</label
          >
          <v-select
            :options="listStatusPosVistoria"
            name="Status"
            label="label"
            id="idStatusPosVistoria"
            v-model="formCadastro.idStatusPosVistoria"
            @input="
              emitChangedForm('idStatusPosVistoria', form.idStatusPosVistoria)
            "
            class="select-large w-full"
            :reduce="(item) => item.id"
            :state="validateState('Status')"
            :danger="validateClass('Status')"
            :disabled="
              !this.$can('Permite alterar Status Pós Vistoria', 'Usuário')
            "
          ></v-select>
        </div>
      </div>

      <div v-if="!this.dados.idUsuario" class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Senha de Acesso</span>
          <vs-input
            size="large"
            class="w-full"
            name="Senha"
            id="Senha"
            v-model="formCadastro.senha"
            v-validate="{ required: true, min: 6 }"
            :state="validateState('Senha')"
            :danger="validateClass('Senha')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
            type="password"
          />
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idUsuario == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <vs-popup
      class="holamundo"
      :title="`Informações da ${$t('Regional')}`"
      @cancel="clearFormRegional"
      :active.sync="activePromptRegionais"
    >
      <div>
        Termine de informar os dados da {{ $t('Regional') }} para
        <b>continuar</b>.
        <vs-input
          placeholder="Estado"
          v-model="formRegional.estado"
          class="mt-4 mb-2 w-full"
        />
        <vs-input
          placeholder="Cidade"
          v-model="formRegional.cidade"
          class="w-full"
        />
        <vs-button color="success" class="w-full mt-2">Cadastar</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import cpfCnpj from '../../services/cpfCnpj';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import formAddRegional from '../forms/formAddRegional.vue';
import jwt from 'jsonwebtoken';
import functions from '../../utils/functions';
import ability from '../../services/ability';
import regionaisService from '../../services/regionais';
import notify from '../../utils/notify';
import GrandUnionFields from '../../components/GrandUnionFields.vue';
import dateConversion from '../../utils/dateConversion';
import { decryptData } from '../../services/decryptData';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    programaEscolhido(newValue) {
      this.formCadastro.idProgramaAfiliado = newValue;
      if (newValue === null) {
        this.usuarioUplineEscolhido = newValue;
      }
    },
    usuarioUplineEscolhido(newValue) {
      this.formCadastro.idUsuarioUpline = newValue;
    },
  },
  computed: {
    programas() {
      return (
        this.formCadastro.idProgramaAfiliado ||
        this.programasAfiliados.length > 0
      );
    },
    cpfCnpjMask() {
      return this.currentMask;
    },
    urlFoto() {
      return this.urlFotoLocal || this.formCadastro.profilePic;
    },
    translatedDivision() {
      return this.$t('Divisão');
    },
    translatedRegional() {
      return this.$t('Regional');
    },
  },
  data() {
    return {
      aguardeCadastro: false,
      idEmpresa: null,
      idUsuario: null,
      hasPermission: false,
      regionais: [],
      divisoes: [],
      perfis: [],
      setores: [],
      listStatusPosVistoria: [],
      languages: lang,
      funcoesValicao: null,
      titleSideBar: `Adicionar ${this.$t('Regional')}`,
      dadosSideBar: {},
      regionaisUsuario: [],
      programasAfiliados: [],
      usuariosUpline: [],
      programaEscolhido: null,
      usuarioUplineEscolhido: null,
      modalForm: false,
      arrTtiposProposta: [
        'Adesão',
        'Reativação',
        'Substituição',
        'Inclusão',
        'Troca de Titularidade',
        'Migração',
      ],
      formCadastro: {
        metaTipoPropostaPadrao: null,
        metaPadrao: null,
        idUsuario: null,
        idEmpresa: null,
        status: true,
        nome: '',
        consultor: false,
        podeFazerVistoria: false,
        email: '',
        cpf: '',
        celular: '',
        telefone: '',
        dataNascimento: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: 'Brasil',
        idSetor: '',
        idPerfil: '',
        idRegional: [],
        senha: '',
        userName: '',
        idRegionais: [],
        idDivisao: null,
        idProgramaAfiliado: null,
        idUsuarioUpline: null,
        idStatusPosVistoria: '',
        valorContribuicao: null,
        profilePic: null,
      },
      activePromptRegionais: false,
      formRegional: {
        idEmpresa: '',
        estado: '',
        cidade: '',
        nome: '',
      },
      isMobile: true,
      customPercentageFromChild: null,
      customClass: '',
      enabledGrandUnion: false,
      cpfMask: '###.###.###-##',
      cnpjMask: '##.###.###/####-##',
      currentMask: '###.###.###-##',
      arquivoSelecionado: null,
      urlFotoLocal: null,
      erroImagem: null,
    };
  },
  methods: {
    async preencheForm() {
      this.buscaDadosSelects('setor', 'setores', 'nomeSetor', 'idSetor');
      this.buscaDadosPerfil('perfis', 'perfis', 'nomePerfil', 'idPerfil');
      this.buscaDadosStatus(
        'domStatusCotacao',
        'listStatusPosVistoria',
        'nomeStatus',
        'idStatus',
      );
      await this.buscaRegionaisDivisoes();

      if (this.dados.idUsuario) {
        this.formCadastro.idStatusPosVistoria = this.dados.idStatusPosVistoria;
        this.formCadastro.idUsuario = this.dados.idUsuario;

        const dadosDivisao = this.filtrarDivisaoPadrao();
        if (dadosDivisao) {
          this.formCadastro.idDivisao = {
            id: dadosDivisao.idDivisao,
            label: dadosDivisao.nomeDivisao,
          };
        }

        if (this.dados.cpf.length > 14) {
          this.currentMask = this.cnpjMask;
        }

        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nome = this.dados.nome;
        this.formCadastro.consultor = this.dados.consultor;
        this.showGrandUnion(this.formCadastro.consultor);
        this.formCadastro.podeFazerVistoria = this.dados.podeFazerVistoria;
        this.formCadastro.email = this.dados.email;
        this.formCadastro.cpf = this.dados.cpf;
        this.formCadastro.celular = this.dados.celular;
        this.formCadastro.telefone = this.dados.telefone;
        this.formCadastro.dataNascimento = dateConversion.converteISOToDate(
          this.dados.dataNascimento,
        );
        this.formCadastro.cep = this.dados.cep;
        this.formCadastro.endereco = this.dados.endereco;
        this.formCadastro.numero = this.dados.numero;
        this.formCadastro.complemento = this.dados.complemento;
        this.formCadastro.bairro = this.dados.bairro;
        this.formCadastro.cidade = this.dados.cidade;
        this.formCadastro.estado = this.dados.estado;
        this.formCadastro.pais = this.dados.pais;
        this.formCadastro.userName = this.dados.userName;
        this.formCadastro.idRegionais = this.regionaisUsuario;
        this.formCadastro.metaPadrao = this.dados.metaPadrao;
        this.formCadastro.metaTipoPropostaPadrao =
          this.dados.metaTipoPropostaPadrao;
        this.formCadastro.idSetor = {
          id: this.dados.idSetor,
          label: this.dados.Setor,
        };
        this.formCadastro.idPerfil = {
          id: this.dados.idPerfil,
          label: this.dados.Perfil,
        };
        this.formCadastro.idRegional = {
          id: this.dados.idRegional,
          label: this.dados.Regional,
        };
        this.formCadastro.senha = this.dados.senha;
        this.formCadastro.idProgramaAfiliado = this.dados.idProgramaAfiliado;
        this.formCadastro.idUsuarioUpline = this.dados.idUsuarioUpline;
        this.buscaProgramaAfiliadosParaEdicao(
          this.dados.idRegional,
          this.dados.ProgramaAfiliado,
          this.dados.UsuarioUpline,
        );
        this.formCadastro.valorContribuicao = this.dados.valorContribuicao;
        this.formCadastro.profilePic = this.dados.profilePic;
        this.buscaDivisao(this.dados.idRegional);
      } else {
        this.resetForm();
        this.defineIdStatusPosVistoriaInicial();
        this.verificaPermissao();
      }
    },

    criaPerfil(event) {
      //this.$vs.loading();
      var formAdd = {
        idEmpresa: this.idEmpresa,
        nomePerfil: event.label,
      };
      service
        .post('g', 'perfis/create/idPerfil', formAdd)
        .then((res) => {
          res.data = decryptData(res.data);
          var adicionado = {
            id: res.data.idPerfil,
            label: event.label,
          };
          this.perfis.push(adicionado);
          this.formCadastro.idPerfil = adicionado;
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Perfil adicionado com sucesso',
            color: 'success',
          });
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Perfil não pode ser adicionado',
            color: 'danger',
          });
        });
    },
    criaSetor(event) {
      this.$vs.loading();
      var formAdd = {
        idEmpresa: this.idEmpresa,
        nomeSetor: event.label,
      };
      service
        .post('g', 'setor/create/idSetor', formAdd)
        .then((res) => {
          res.data = decryptData(res.data);
          var adicionado = {
            id: res.data.idSetor,
            label: event.label,
          };
          this.setores.push(adicionado);
          this.formCadastro.idSetor = adicionado;
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Setor adicionado com sucesso',
            color: 'success',
          });
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Setor não pode ser adicionado',
            color: 'danger',
          });
        });
    },
    criaRegional(event) {
      this.formRegional.idEmpresa = this.idEmpresa;
      this.formRegional.nome = event;
      this.activePromptRegionais = true;
    },
    clearFormRegional() {
      this.activePromptRegionais = false;
      this.formRegional = {
        idEmpresa: '',
        estado: '',
        cidade: '',
        nome: '',
      };
    },

    openModalInsertEdit(dados) {
      const { idRegional } = dados;

      !idRegional
        ? (this.titleSideBar = `Adicionar ${this.$t('Regional')}`)
        : (this.titleSideBar = `Editar Regionais do Usuario`);

      this.modalForm = true;
    },
    closeModais(data) {
      this.formCadastro.idRegionais = data;
      this.regionaisUsuario = data;
      this.modalForm = false;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    onSelectPercentagem({ customPercentage }) {
      this.customPercentageFromChild = customPercentage;
    },
    async onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;
      const { aplicaContribuicao } = await this.buscaConfigEmpresa();
      let customPercentage = this.customPercentageFromChild;

      var action = 'Atualizar';
      // eslint-disable-next-line no-unused-vars
      let msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idUsuario) {
        action = 'Adicionar';
        msgRetorno = 'Usuário Adicionado com sucesso';
      }

      if (cpfCnpj.valida_cpf_cnpj(this.formCadastro.cpf) == false) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Este CPF não é válido`,
          color: 'danger',
        });
        return;
      }

      if (!this.formCadastro.idDivisao) {
        if (this.hasPermission == true) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `A ${this.$t('Regional')} deve possuir apenas uma ${this.$t(
              'Divisão',
            )}`,
            color: 'danger',
          });
          return;
        } else {
          this.formCadastro.idDivisao = [this.decoded.id_divisao];
          this.formCadastro.idRegional = { id: this.decoded.id_regional };
        }
      }

      if (
        aplicaContribuicao &&
        this.formCadastro.consultor &&
        !customPercentage
      ) {
        this.customClass = 'border-red';
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Favor preencher o valor de contribuição.`,
          color: 'danger',
        });
        return;
      }

      const MINIMUM_CONTRIBUTION = 3;
      if (
        aplicaContribuicao &&
        this.formCadastro.consultor &&
        customPercentage < MINIMUM_CONTRIBUTION
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Valor mínimo: ${MINIMUM_CONTRIBUTION}%.`,
          color: 'danger',
        });
        return;
      }

      const TOTAL_CONTRIBUITION = 100;
      if (customPercentage >= TOTAL_CONTRIBUITION) {
        customPercentage = TOTAL_CONTRIBUITION;
      }

      try {
        this.$vs.loading();
        const isValid = await this.$validator.validateAll();

        if (isValid) {
          this.$set(
            this.formCadastro,
            'valorContribuicao',
            Number(customPercentage),
          );

          const { data } = await service.post(
            'Usuario',
            action,
            this.formCadastro,
          );

          if (data.id && this.arquivoSelecionado) {
            await this.uploadFotoSelecionada(data.id, this.arquivoSelecionado);
          }

          this.aguardeCadastro = false;

          this.$emit('concluido');
          this.resetaDadosDoPrograma();

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Operação Realizada com sucesso',
            color: 'success',
          });

          return;
        }

        throw new Error('Confira os dados e tente novamente.');
      } catch (error) {
        this.aguardeCadastro = false;

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error.message || error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    keymonitor: function () {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formCadastro.cep.replace('.', '').replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            res.data = decryptData(res.data);
            this.formCadastro.endereco = res.data.street;
            this.formCadastro.bairro = res.data.neighborhood;
            this.formCadastro.cidade = res.data.city;
            this.formCadastro.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
              estado: element.estado,
              cidade: element.cidade,
            });
          });
        });
    },
    buscaDadosStatus(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          if (array == 'listStatusPosVistoria') {
            if (element[campoPK] == 3 || element[campoPK] == 7)
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      });
      this.defineIdStatusPosVistoriaInicial();
    },
    async buscaDadosPerfil(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          res.data.forEach((element) => {
            if (!this.$can('Permite editar Perfil', 'Usuário')) {
              if (element.nomePerfil.indexOf('Consultor') >= 0) {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                  estado: element.estado,
                  cidade: element.cidade,
                });
              }
            }

            if (this.$can('Permite editar Perfil', 'Usuário')) {
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
                estado: element.estado,
                cidade: element.cidade,
              });
            }
          });
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Perfil não pode ser encontrado',
            color: 'danger',
          });
        });
    },
    resetForm() {
      this.formCadastro = {
        status: true,
        nome: '',
        consultor: false,
        podeFazerVistoria: false,
        email: '',
        cpf: '',
        celular: '',
        telefone: '',
        dataNascimento: '',
        cep: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: 'Brasil',
        idSetor: '',
        idPerfil: '',
        idRegional: '',
        senha: '',
        userName: '',
        regionais: '',
        idStatusPosVistoria: '',
        valorContribuicao: null,
        profilePic: null,
      };
      this.customClass = '';
      this.enabledGrandUnion = false;
      this.arquivoSelecionado = null;
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
    async buscaProgramaAfiliados(idRegional) {
      this.$vs.loading();
      const objSend = {
        idEmpresa: this.idEmpresa,
        idRegional,
      };

      return await service
        .post('programa-afiliados', '/buscar-programa-afiliados', objSend)
        .then((res) => {
          this.$vs.loading.close();
          this.resetaDadosDoPrograma();
          this.verifcarSeExistePrograma(res.data) &&
            this.preencheProgramaAfiliados(res.data);
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Falha ao buscar os Programas de Afiliados',
            color: 'danger',
          });
        });
    },
    resetaDadosDoPrograma() {
      this.programasAfiliados = [];
      this.usuariosUpline = [];
      this.programaEscolhido = null;
      this.usuarioUplineEscolhido = null;
    },
    verifcarSeExistePrograma(dados) {
      return typeof dados === 'object' && typeof dados !== 'string';
    },
    preencheProgramaAfiliados(dados) {
      this.programasAfiliados = [
        {
          id: dados.idPrograma,
          label: dados.nome,
        },
      ];
      dados.usuariosUpline.length > 0 &&
        this.preencheUsuariosUpline(dados.usuariosUpline);
    },
    preencheUsuariosUpline(usuarios) {
      this.usuariosUpline = usuarios
        .map((usuario) => {
          return {
            id: usuario.id_usuario,
            label: usuario.nome,
          };
        })
        .filter((usuario) => usuario.id !== this.formCadastro.idUsuario);
    },
    async buscaProgramaAfiliadosParaEdicao(
      idRegional,
      programa,
      usuarioUpline,
    ) {
      await this.buscaProgramaAfiliados(idRegional);
      this.preencherProgramaAfiliadoParaEdicao(programa, usuarioUpline);
    },
    preencherProgramaAfiliadoParaEdicao(programa, usuarioUpline) {
      if (programa) {
        const selecionado = this.programasAfiliados.find(
          (a) => a.id === programa.idPrograma,
        );
        this.programaEscolhido = selecionado.id || null;
      }
      if (usuarioUpline) {
        const selecionado = this.usuariosUpline.find(
          (b) => b.id === usuarioUpline.idUsuario,
        );
        this.usuarioUplineEscolhido = selecionado.id || null;
      }
    },
    defineIdStatusPosVistoriaInicial() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.idEmpresa = this.decoded.id_empresa;
      if (functions.verificaEmpresaBemProtege(this.idEmpresa)) {
        this.formCadastro.idStatusPosVistoria = 7;
      } else {
        this.formCadastro.idStatusPosVistoria = 3;
      }
    },
    async buscaRegionaisDivisoes() {
      try {
        const regionais = await regionaisService.buscaRegionais(this.idEmpresa);

        this.regionais = regionais;
      } catch (e) {
        notify.notifyFail(this.$vs, 'Falha ao buscar os Regionais e Divisões');
      }
    },
    buscaDivisao(idRegional) {
      const { divisoes } = this.regionais.find(
        (regional) => regional.id === idRegional,
      );

      this.divisoes = [];
      this.formCadastro.idDivisao = [];

      divisoes.forEach((element) => {
        this.divisoes.push({
          id: element.idDivisao,
          label: element.nomeDivisao,
        });
        this.formCadastro.idDivisao.push(element.idDivisao);
      });
    },
    verificaPermissao() {
      var permissoes = ability.getPermission().$;

      var arrayHasPermission = permissoes.filter(
        (x) =>
          x.subject == 'Usuário' && x.action == 'Permitir alterar regional',
      );
      if (arrayHasPermission.length > 0) this.hasPermission = true;
      if (this.hasPermission == false) {
        this.buscaProgramaAfiliados(this.decoded.id_regional);
      }
    },
    async buscaConfigEmpresa() {
      try {
        const model = 'g';
        const action = 'empresas/list/idEmpresa/';
        this.$vs.loading();
        const response = await service.getAll(
          model,
          {},
          action + this.decoded.id_empresa,
        );

        if (!response.data || response.data.length === 0) {
          return null;
        }

        this.$vs.loading.close();
        return response.data[0];
      } catch (error) {
        this.$vs.loading.close();
        console.error('Erro durante a buscaConfigEmpresa:', error);
        throw error;
      }
    },
    verificaBemProtege() {
      const token = localStorage.getItem('user-token');

      if (!token) {
        this.buscaDadosToImpressao();
        return;
      }

      let decoded = null;
      if (token) {
        decoded = jwt.decode(token);
      }
      const idEmpresa = decoded.id_empresa;
      return functions.verificaEmpresaBemProtege(idEmpresa);
    },
    async showGrandUnion(consultor) {
      const { aplicaContribuicao } = await this.buscaConfigEmpresa();

      const isValidGrandUnion =
        this.verificaBemProtege() && consultor && aplicaContribuicao;
      this.enabledGrandUnion = isValidGrandUnion;
    },
    handleSwitchChange() {
      const { consultor } = this.formCadastro;

      if (!consultor) {
        this.enabledGrandUnion = false;
        return;
      }

      this.showGrandUnion(consultor);
    },
    filtrarDivisaoPadrao() {
      const divisoesRegional = this.regionais.find(
        (regional) => regional.id === this.dados.idRegional,
      );

      const temDivisoesRegionais =
        divisoesRegional && divisoesRegional.divisoes.length;

      if (temDivisoesRegionais) {
        const _divisoesRegionais = divisoesRegional.divisoes.filter(
          (divisao) => divisao.idDivisao,
        );

        const dadosDivisao = _divisoesRegionais.find(
          (divisao) => divisao.idDivisao === this.dados.idDivisao,
        );

        return dadosDivisao;
      }
    },
    updateMask() {
      if (this.formCadastro.cpf.replace(/\D/g, '').length > 11) {
        this.currentMask = this.cnpjMask;
      } else {
        this.currentMask = this.cpfMask;
      }
    },

    validaExtensaoArquivo(arquivo, event) {
      const tiposPermitidos = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!tiposPermitidos.includes(arquivo.type)) {
        this.erroImagem =
          'Formato de arquivo inválido. Apenas .jpg, .jpeg e .png são permitidos.';
        this.limpaInputFoto(event);
        return false;
      }
      return true;
    },

    validaTamanhoArquivo(arquivo, tamanhoEmMegabytes, event) {
      const tamanhoMaximo = tamanhoEmMegabytes * 1024 * 1024;
      if (arquivo.size > tamanhoMaximo) {
        this.erroImagem = `A imagem selecionada excede o limite de ${tamanhoEmMegabytes}MB.`;
        this.limpaInputFoto(event);
        return false;
      }
      return true;
    },

    limpaInputFoto(event) {
      this.urlFotoLocal = null;
      event.target.value = null;
    },

    selecionaArquivoUpload(event) {
      this.arquivoSelecionado = event.target.files[0];

      if (!this.arquivoSelecionado) {
        return;
      }

      if (!this.validaExtensaoArquivo(this.arquivoSelecionado, event)) {
        return;
      }

      if (!this.validaTamanhoArquivo(this.arquivoSelecionado, 2, event)) {
        return;
      }

      this.erroImagem = null;

      const reader = new FileReader();
      reader.onload = (eventReader) => {
        this.urlFotoLocal = eventReader.target.result;
      };
      reader.readAsDataURL(this.arquivoSelecionado);
    },

    async uploadFotoSelecionada(idUsuario, arquivo) {
      try {
        if (!idUsuario || !arquivo) {
          throw 'Usuário ou arquivo não definido.';
        }

        const formDataSend = new FormData();
        formDataSend.append('files', arquivo);

        const urlFoto = await this.uploadFotoS3(idUsuario, formDataSend);

        await this.registraFotoDB(idUsuario, urlFoto);
      } catch (error) {
        console.error('Erro no upload da foto:', error);
        notify.notifyFail(
          this.$vs,
          `Falha ao enviar a foto do usuário: ${error.message || error}`,
        );
      }
    },

    async uploadFotoS3(idUsuario, formDataSend) {
      try {
        const { uploadedFiles } = await service.uploadAll(
          'upload-multi',
          `Usuarios/${idUsuario}`,
          formDataSend,
        );
        return uploadedFiles[0];
      } catch (error) {
        throw `Erro ao fazer upload para S3: ${error.message || error}`;
      }
    },

    async registraFotoDB(idUsuario, urlS3) {
      try {
        await service.post('Usuario', 'registra-foto-usuario', {
          idUsuario,
          profilePic: urlS3,
        });
      } catch (error) {
        throw `Erro ao registrar a foto no banco de dados: ${
          error.message || error
        }`;
      }
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
    this.verificaBemProtege();
  },
  mounted() {
    this.$i18n.locale = functions.setLocaleBasedOnCompany();
  },
  components: {
    BotaoSubmit,
    'v-select': vSelect,
    formAddRegional,
    GrandUnionFields,
  },
};
</script>

<style scoped>
.warning {
  color: red;
}
</style>
<!------------ END SCRIPT ------------>
